import { API_INVOICE_BASE_URL } from 'shared/config/env';

import { setupInterceptors } from '../interceptors';

import { createApiClient } from './base-client';

const clientV2 = createApiClient(API_INVOICE_BASE_URL);
setupInterceptors(clientV2);

export default clientV2;
